import { defineComponent } from '@vue/composition-api'
import { LiteralUnion } from 'vtils/types'
import { useContext, UseContextResult } from './use_context'

export type DefineClassComponentOptions<P extends Record<string, any> = {}> = {
  name?: string
  model?: {
    prop: keyof P
    event: LiteralUnion<'input' | 'change', string>
  }
  components?: Record<string, any>
  props?: Array<keyof P>
  inheritAttrs?: boolean
}

export type DefineClassComponentFactory<P extends Record<string, any> = {}> =
  (payload: { props: P; ctx: UseContextResult }) => new () => any

export function defineClassComponent<P extends Record<string, any> = {}>(
  options: DefineClassComponentOptions<P>,
  factory: DefineClassComponentFactory<P>,
): any

export function defineClassComponent<P extends Record<string, any> = {}>(
  factory: DefineClassComponentFactory<P>,
): any

export function defineClassComponent(_options: any, _factory?: any) {
  const options: DefineClassComponentOptions = _factory ? _options : {}
  const factory: DefineClassComponentFactory = _factory ? _factory : _options

  return defineComponent({
    name: options.name,

    components: options.components,

    props: options.props,

    model: options.model,

    inheritAttrs: options.inheritAttrs,

    setup(props) {
      const ctx = useContext()
      const result = new (factory({
        props: props as any,
        ctx: ctx,
      }))()
      if (typeof result?.render === 'function') {
        return result.render
      }
      return result
    },
  })
}
